import styled from 'styled-components';

const DownloadIconSvg = styled.svg`
  width: 16px;
  height: 16px;
  flex-shrink: 0;
`;

export default function DownloadIcon() {
  return (
    <DownloadIconSvg viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <path
        d="M8 2v8M4.25 7l3.75 3.75L11.75 7"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.75 13.5h10.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </DownloadIconSvg>
  );
}
